export default __webpack_public_path__ + "static/media/A0003.38fd25b4.png";